import React from 'react';
// import { bindActionCreators } from "redux";
// import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { Card, CardContent } from '@material-ui/core';


const useStyles = makeStyles({
  card: {
    width: '100%',
    height: 150,
    background: '#fff',
    display: 'flex',
    alignItems: 'center !important',
    cursor: 'pointer',
    borderRadius: 0,
  },
  cardBankDam: {
    width: '100%',
    height: 150,
    background: '#fff',
    display: 'flex',
    alignItems: 'center !important',
    borderRadius: 0,
  },
  logoBank: {
    width: '90%',
  },
});

function CardBank(props) {
  const classes = useStyles();

  return (
    <div>
      <Card className={(props.staticLogoDam ? classes.cardBankDam : classes.card)} elevation={0}>
        <CardContent>
          <img
              src={props.image}
              className={classes.logoBank}
              alt="Logo Banco XXX"
            />
        </CardContent>
       </Card>
    </div>
  );
}

export default CardBank

// const mapStateToProps = (store) => ({
//   openModalDebit: store.cardDebitState.openModalDebitValue,
// })

// const mapDispatchToProps = dispatch =>
//   bindActionCreators({ openModalDebitComp }, dispatch);


// export default connect(mapStateToProps, mapDispatchToProps)(CardDebit)